namespace AgerLMS.WebSite {

    export interface RegisterWidgetRequest {

    }

    //https://ajax.aspnetcdn.com/ajax/jquery.validate/1.11.1/additional-methods.js
    @Serenity.Decorators.registerClass()
    export class RegisterWidget extends Serenity.Widget<RegisterWidgetRequest> {

        button : string = "#RegisterButton";
        formSelector : string = "#RegisterForm";

        constructor(element: JQuery, opt: RegisterWidgetRequest) {
            super(element, opt);

            var form = $(this.formSelector);
            form.find("input[name='email']").val("receptuna@test.com");
            form.find("input[name='full_name']").val("receptuna");
            form.find("input[name='phone']").val("05051189912");
            form.find("input[name='password']").val("12345678");
            form.find("input[name='password_confirmation']").val("12345678");
            form.find("input[name='tc_no']").val("15847649206");
            form.find("input[name='birth_date']").val("15847649206");

            this.bindValidate();

            $(this.button).click(e => {
                e.preventDefault();

                // $("#RegisterForm").submit();
                if (!$(this.formSelector).valid()) return;

                var userRow = <Administration.UserRow>{};
                userRow.Email = form.find("input[name='email']").val();
                userRow.Username = form.find("input[name='email']").val();
                userRow.DisplayName = form.find("input[name='full_name']").val();
                userRow.MobilePhoneNumber = form.find("input[name='phone']").val();
                userRow.Password = form.find("input[name='password']").val();
                userRow.TcNo = form.find("input[name='tc_no']").val();
                userRow.BirthDate = form.find("input[name='birth_date']").val();
                // userRow.Source = "website";
                userRow.TwoFactorAuth = Administration.TwoFactorAuthType.SMS;
                userRow.MobilePhoneVerified = true;
                userRow.UserGroup = UserGroups.Student;
                userRow.Bio = form.find("input[name='email']").val() + " " + form.find("input[name='full_name']").val();
                userRow.Roles = [2]; // Student

                Administration.PublicUserService.CheckUserForRegisterSMS({ Entity: userRow }, response => {
                    // Kullanıcı kayıt için uygun ise
                    this.checkRegistrationSMS(userRow.TcNo + userRow.MobilePhoneNumber + userRow.Email, response.Guid, response.Message, 
                        () => {
                            Administration.PublicUserService.UserSave({ Entity: userRow }, () => {
                                //Kullanıcı kayıt işlemi başarılı ise yönlendirme yapılacak
                                Swal.fire({
                                    title: 'Kullanıcı Oluşturuldu! Sistemi Kullanmaya Başlayabilirsiniz.',
                                    text: 'Giriş sayfasına yönleniyor. Lütfen Bekleyiniz...',
                                    icon: 'success',
                                    timer: 2000,
                                    buttons: false,
                                })
                                .then(() => {
                                    window.location.href = Q.resolveUrl('~/giris');;
                                })
                                
                            }, { onError: (e) => { SweetAlert.swal_alert("Hata", e.Error.Message); } });
                        }
                    );
                }, 
                { 
                    onError: response => {
                        SweetAlert.swal_alert(response.Error.Message, response.Error.Message)
                    }
                });

            });

            $(document).keypress(function(e){
                if (e.which == 13){
                    $(this.button).click();
                }
            });
        }

        private checkTcNum(value) {
            value = value.toString();
            var isEleven = /^[0-9]{11}$/.test(value);
            var totalX = 0;
            for (var i = 0; i < 10; i++) {
              totalX += Number(value.substr(i, 1));
            }
            var isRuleX = totalX % 10 == value.substr(10,1);
            var totalY1 = 0;
            var totalY2 = 0;
            for (var i = 0; i < 10; i+=2) {
              totalY1 += Number(value.substr(i, 1));
            }
            for (var i = 1; i < 10; i+=2) {
              totalY2 += Number(value.substr(i, 1));
            }
            var isRuleY = ((totalY1 * 7) - totalY2) % 10 == value.substr(9,0);
            return isEleven && isRuleX && isRuleY;
          };

        private bindValidate() {
            var self = this;

            $(".reveal").on('click',function() {
                var $password = $(this).parent().children("input");
                var $i = $(this).children().children("i");
                if ($password.attr('type') === 'password') {
                    $password.attr('type', 'text');
                    $i.removeClass("fa-eye-slash");
                    $i.addClass("fa-eye");
                } else {
                    $password.attr('type', 'password');
                    $i.removeClass("fa-eye");
                    $i.addClass("fa-eye-slash");
                }
            });

            $.validator.addMethod('trPhone', function(value, element) {
                return value.match(/05[0-9]{8}/);
            },"Geçerli telefon numarası girin. SMS ile doğrulama kodu alacaksınız.");

            $.validator.addMethod('tc_validate', function(value, element) {
                return self.checkTcNum(value);
            },"Geçerli bir TC Kimlik numarası girin!");

            $(self.formSelector).validate({
                errorClass: "is-invalid",
                rules: {
                    full_name: "required",
                    email: {
                        required: true,
                        email: true
                    },
                    phone: { required : true, trPhone : true, minlength: 11, maxlength: 11 },           
                    tc_no: { required : true, tc_validate : true, minlength: 11, maxlength: 11 },           
                    password: {
                        required: true,
                        minlength: 8
                    },
                    password_confirmation: {
                        required: true,
                        equalTo: "[name='password']"
                    },
                    term: "required",
                    birth_date: { required : true, date: true },
                },
                messages: {
                    full_name: "* Lütfen adınızı belirtin",
                    email: {
                        required: "* Sizinle iletişim kurmak için e-posta adresinize ihtiyacımız var!",
                        email: "* E-posta adresiniz ogrenci@xxx.xxx biçiminde olmalıdır!"
                    },
                    phone: {
                        required: "* Sizinle iletişim kurmak için cep telefonunuz gereklidir! SMS ile doğrulama kodu alacaksınız. 05XXXXXXXXX",
                        trPhone: "* Geçerli bir cep telefonu numarası girin! Sms ile doğrulama kodu alacaksınız.",
                        minlength : "* Geçerli bir cep telefonu numarası girin! Sms ile doğrulama kodu alacaksınız.",
                        maxlength: "* Geçerli bir cep telefonu numarası girin! Sms ile doğrulama kodu alacaksınız."
                    },
                    tc_no: {
                        required: "* TC Kimlik numaranız gereklidir!",
                        tc_validate: "* Geçerli bir TC Kimlik numarası girin!",
                        minlength : "* Geçerli bir TC Kimlik numarası girin!",
                        maxlength: "* Geçerli bir TC Kimlik numarası girin!"
                    },
                    password: {
                        required: "* Şifrenizi belirtin",
                        minlength:"* Şifreniz en az 8 karakter olmalıdır!"
                    },
                    password_confirmation: {
                        required: "* Şifrenizi tekrar girin",
                        equalTo:"* Şifreleriniz uyuşmuyor!"
                    },
                    term: "* Lütfen şartları kabul ediniz!",
                    birth_date: {
                        required: "* Doğum Tarihiniz gereklidir! gün.ay.yıl şeklinde giriniz.",
                    },
                },
                errorPlacement: function(error, element) {
                    $(element).parents('.form-group').append(error)
                }
            });
        }

        protected checkRegistrationSMS(user: string, registerAuthGuid: string, message: string, onSuccess: () => void) {
            var tries = 0;
            let timerInterval
            var sw = Swal.fire({
                title: 'Kullanıcı Kaydı SMS Doğrulama',
                html: message,
                timer: 2 * 60 * 1000,
                timerProgressBar: true,
                input: 'text',
                inputAttributes: {
                  autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Kodu Onayla',
                cancelButtonText: 'İptal',
                showLoaderOnConfirm: true,
                didOpen: () => {
                    const b = Swal.getHtmlContainer().querySelector('span.counter')
                    timerInterval = setInterval(() => {
                      b.textContent = (Swal.getTimerLeft() / 1000).toFixed(0);
                    }, 1000)
                },
                willClose: () => {
                    clearInterval(timerInterval)
                },
                preConfirm: (x) => {
                    if (x >= 1000 && x <= 9999) {
                        tries++;
                        
                        Q.serviceCall({
                            url: Q.resolveUrl('~/Services/Administration/PublicUser/CheckSmsForRegistration'),
                            request: {
                                Username: user,
                                Guid: registerAuthGuid,
                                Code: x
                            },
                            onSuccess: (r) => {
                                onSuccess();
                                return true;
                            },
                            onError: (z: Serenity.ServiceResponse) => {
                                if (tries > 2) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Oops...',
                                        text: 'Girilen kod geçersiz! 3 defadan fazla deneyemezsiniz!',
                                      })
                                    return true;
                                }
                                Swal.showValidationMessage(`${z.Error.Message}`)

                                // sw();
                            }
                        });
                
                        return false;
                    }
                    else Swal.showValidationMessage(`Lütfen geçerli bir kod girin!`)
                },
                allowOutsideClick: () => !Swal.isLoading(),
            }).then(r => {
                // Q.notifyInfo(JSON.stringify(r));
            });
        }
    }
}